module.exports = __webpack_public_path__ + "img/caseZJSFDX.ad4ee332.jpg";